import { render, staticRenderFns } from "./ToufangSelf2.vue?vue&type=template&id=77dc71ec&scoped=true&"
import script from "./ToufangSelf2.vue?vue&type=script&lang=js&"
export * from "./ToufangSelf2.vue?vue&type=script&lang=js&"
import style0 from "./ToufangSelf2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ToufangSelf2.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ToufangSelf2.vue?vue&type=style&index=2&id=77dc71ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc71ec",
  null
  
)

export default component.exports